import { IPushOrderDTO, IPushOrderResponse, staticOrdersEndpoints } from '@/models/order.model';
import { httpClient, ApiResponse } from '@/utils';

class OrdersAPI {
  static pushOrder(data: IPushOrderDTO): ApiResponse<IPushOrderResponse> {
    const { PUSH_ORDER } = staticOrdersEndpoints;
    return httpClient.post<IPushOrderResponse>(PUSH_ORDER, data);
  }
}

export default OrdersAPI;
